import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    border: `1px solid ${semanticColors.border.secondary}`,
    borderRadius: "4px",
    marginTop: "16px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    padding: "16px",
    alignItems: "center",
  },
  headerWithIcon: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  arrowDownButton: {
    background: "transparent",
    padding: 0,
    border: "none",
    boxShadow: "none",
    marginRight: "8px",
  },
  proposalContainer: {},
  content: {
    display: "flex",
    padding: "16px",
    justifyContent: "space-between",
  },
  proposalActionContent: {
    display: "flex",
    gap: "12px",
    alignItems: "center",
  },
  iconColor: {
    color: semanticColors.foreground.action,
    fill: semanticColors.foreground.action,
  },
  moreButton: {
    background: "transparent",
    padding: 0,
    border: "none",
    boxShadow: "none",
    transform: "rotate(90deg)",
  },
  proposalFieldsContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    gap: "8px",
  },
  proposalFields: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "208px",
    wordWrap: "break-word",
  },
  mergeTag: {
    display: "inline-flex",
  },
  warningIcon: {
    color: semanticColors.foreground.errorLarge,
  },
  infoIconWrapper: {
    display: "inline-flex",
    alignItems: "center",
  },
  infoIconButton: {
    all: "unset",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
  },
  externalLinkIcon: {
    color: semanticColors.foreground.action,
    fill: semanticColors.foreground.action,
    display: "flex",
    alignItems: "center",
  },
  srOnly: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0,0,0,0)",
    whiteSpace: "nowrap",
    border: 0,
  },
});
